import React, { useEffect, useState } from 'react'
import { activePath, selectCurve } from '../../redux/tools/actions'
import { connect } from 'react-redux'
import './Scene.css'
import { Spinner } from 'reactstrap'
import MiniEditor from './miniEditor/MiniEditorV1'
import MiniEditorV1 from './miniEditor/MiniEditorV1'
import MiniEditorV2 from './miniEditor/MiniEditorV2'
import classnames from 'classnames'

const Home = (props) => {
    let [show, setShow] = useState(false)
    let [points, setPoints] = useState([])
    var paper = window.paper
    var tool = new paper.Tool()

    useEffect(() => {
        tool.onMouseMove = function (event) {
            //console.log(event.point);
            if (paper.project.hitTest(event.point)) {
                props.activePath(paper.project.hitTest(event.point).item._id)
            } else {
                props.activePath(null)

                if (window.paper.project._activeLayer?._children)
                    window.paper.project._activeLayer._children.forEach((q) => {
                        q.opacity = 0
                    })
            }
        }
    }, [])

    useEffect(() => {
        tool.onMouseDown = function (event) {
            if (paper.project.hitTest(event.point)) {
                props.selectCurve(
                    paper.project.hitTest(event.point).item._id,
                    props.roomInDesignStage
                )
            }
        }
        if (!props.isPhotoEditorVisible && props.hoveredPathId) {
            window.paper.project._activeLayer._children.forEach((q) => {
                if (q._id === props.hoveredPathId) {
                    q.opacity = 0.7
                } else {
                    q.opacity = 0
                }
            })
        }
    }, [props.hoveredPathId])

    useEffect(() => {}, [props.choosedPrespective])

    let selectionClassNames = classnames({
        'not-selectable': props.isPhotoEditorVisible,
    })

    return (
        <div
            id="scene-container"
            style={{
                height: 'calc(100vh - 40px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <canvas id="main-scene"></canvas>
            <canvas
                style={{
                    background: 'tansparent',
                    position: 'absolute',
                    zIndex: '10',
                }}
                className={selectionClassNames}
                id="selection"
            ></canvas>
            <canvas
                hidden
                style={{
                    background: 'tansparent',
                    position: 'absolute',
                    zIndex: '-10',
                }}
                id="test"
            ></canvas>
            <canvas
                style={{
                    background: 'tansparent',
                    position: 'absolute',
                    zIndex: '9',
                }}
                id="test2"
            ></canvas>
            {(props.isDrawing || props.uploading) && (
                <div className="draw-loading-wrapper">
                    <Spinner
                        style={{ width: '3rem', height: '3rem' }}
                        color="light"
                    />
                    <h3>لطفا منتظر بمانید</h3>
                </div>
            )}
            <MiniEditorV1 isVisible={!props.isPhotoEditorVisible} />
            <MiniEditorV2 isVisible={!props.isPhotoEditorVisible} />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        roomPaths: state.tools.roomPaths,
        isPhotoEditorVisible: state.tools.isPhotoEditorVisible,
        hoveredPathId: state.tools.hoveredPathId,
        choosedPrespective: state.tools.choosedPrespective,
        isMiniEditorVisible: state.tools.isMiniEditorVisible,
        isDrawing: state.tools.isDrawing,
        uploading: state.user.uploading,
        roomInDesignStage: state.tools.roomInDesignStage,
        multiply: state.tools.multiply,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        activePath: (id) => dispatch(activePath(id)),
        selectCurve: (id, roomInDesignStage) =>
            dispatch(selectCurve(id, roomInDesignStage)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
